import script from "./LinkBottomComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkBottomComponent.vue?vue&type=script&setup=true&lang=js"

import "./LinkBottomComponent.vue?vue&type=style&index=0&id=457c562c&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-457c562c"]])

export default __exports__